<template>
  <v-container class="justify-center pa-5">
    <v-card
      :loading="isLoading"
      height="height"
    >
      <v-card-title
        primary-title
        class="justify-center"
      >
        <h3 class="headline mb-1 mt-2 ml-2">Audience Info</h3>
      </v-card-title>
      <v-card-text>
        <v-container
          v-if="!isLoading"
          fluid
        >
          <v-row
            justify="space-around"
            class="pb-3"
          >
            <v-col
              md="6"
              lg="5"
            >
              <v-text-field
                filled
                readonly
                dense
                hide-details="auto"
                label="Name"
                :value="audience.display_name"
              >
              </v-text-field>
            </v-col>
            <v-col
              md="6"
              lg="5"
              v-if="!showVideoampMetadata"
            >
              <v-text-field
                filled
                readonly
                dense
                hide-details="auto"
                label="Advertiser"
                :value="advertiserName"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row
            justify="space-around"
            class="pb-3"
          >
            <v-col
              md="6"
              lg="5"
            >
              <v-row
                v-if="
                  !hasDigitalDestinations &&
                  !showForesiteMetadata &&
                  !showBroadcastQuarter &&
                  !(isDigitalTarget && isWorkingStatus) &&
                  !showVideoampMetadata
                "
                class="pa-3 pb-0"
              >
                <v-text-field
                  filled
                  readonly
                  dense
                  hide-details="auto"
                  label="Viewing Stream"
                  :value="viewingStream"
                >
                </v-text-field>
              </v-row>
              <v-row
                v-if="hasDigitalDestinations"
                justify="space-between"
              >
                <v-col
                  v-if="isLiveStatus"
                  md="6"
                  class="pb-0"
                >
                  <v-text-field
                    filled
                    readonly
                    dense
                    hide-details="auto"
                    label="Refresh Frequency"
                    :value="frequency"
                  >
                  </v-text-field>
                </v-col>
                <v-col
                  v-if="isLiveStatus"
                  md="6"
                  class="pb-0"
                >
                  <v-text-field
                    filled
                    readonly
                    dense
                    hide-details="auto"
                    label="Refresh Day"
                    :value="exportDayOfWeek"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row
                v-if="showForesiteMetadata || showBroadcastQuarter"
                justify="start"
              >
                <v-col
                  md="4"
                  class="pb-0"
                >
                  <v-text-field
                    filled
                    readonly
                    dense
                    hide-details="auto"
                    label="Viewing Stream"
                    :value="viewingStream"
                  ></v-text-field>
                </v-col>
                <v-col
                  md="4"
                  class="pb-0"
                >
                  <v-text-field
                    filled
                    readonly
                    dense
                    hide-details="auto"
                    label="Broadcast Quarter"
                    :value="broadcastQuarter"
                  ></v-text-field>
                </v-col>
                <v-col
                  md="4"
                  class="pb-0"
                >
                  <v-text-field
                    filled
                    readonly
                    dense
                    hide-details="auto"
                    label="Demo Qualifier"
                    :value="demoQualifier"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row
                v-if="isFlightDatesNotNull"
                justify="space-between"
              >
                <v-col
                  md="6"
                  class="pb-0"
                >
                  <v-text-field
                    filled
                    readonly
                    dense
                    hide-details="auto"
                    label="Flight Start"
                    :value="flightStartDate"
                  >
                  </v-text-field>
                </v-col>
                <v-col
                  md="6"
                  class="pb-0"
                >
                  <v-text-field
                    filled
                    readonly
                    dense
                    hide-details="auto"
                    label="Flight End"
                    :value="flightEndDate"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row
                v-if="isLasActivatedAndNoUE || showMrmId"
                justify="space-between"
                class="pt-3 pb-3"
              >
                <v-col
                  v-if="isLasActivatedAndNoUE"
                  md="6"
                >
                  <v-text-field
                    dense
                    label="UE"
                    v-model="universeEstimate"
                    :rules="UERules"
                    :readonly="!hasPublishPermissions"
                  >
                  </v-text-field>
                </v-col>
                <v-col
                  v-if="showMrmId"
                  md="6"
                >
                  <v-text-field
                    dense
                    label="MRM ID"
                    v-model="mrmId"
                    :rules="mrmIdRules"
                    :readonly="!hasPublishPermissions"
                  ></v-text-field>
                </v-col>
              </v-row>
              <template v-if="showForesiteMetadata">
                <v-row
                  justify="space-between"
                  class="pa-3"
                >
                  <v-text-field
                    filled
                    readonly
                    dense
                    hide-details="auto"
                    label="File Name"
                    :value="foresiteMetadata.pid_file_name"
                  ></v-text-field>
                </v-row>
                <v-row
                  justify="space-between"
                  class="pa-0 pl-3 pr-3"
                >
                  <v-col
                    md="3"
                    class="pl-0 pr-2"
                  >
                    <!-- <v-select
                      v-model="foresiteMetadata.campaign_quarter"
                      :items="campaignQuarterOptions"
                      item-text="name"
                      item-value="value"
                      label="Campaign Qtr"
                      :readonly="hasLake5Destination || !hasPublishPermissions"
                      @input="val => $emit('input', val)"
                      hide-details="auto"
                      dense
                    ></v-select> -->
                    <campaign-quarter-select
                      :initialValue="foresiteMetadata.campaign_quarter"
                      :readonly="hasLake5Destination"
                      @updatedCampaignQuarter="val => (foresiteMetadata.campaign_quarter = val)"
                    >
                    </campaign-quarter-select>
                  </v-col>
                  <v-col
                    md="3"
                    class="pl-2 pr-2"
                  >
                    <v-select
                      v-model="foresiteMetadata.quarter_matched_to"
                      :items="campaignQuarterOptions"
                      item-text="name"
                      item-value="value"
                      label="Qtr Matched To"
                      :readonly="hasLake5Destination || !hasPublishPermissions"
                      @input="val => $emit('input', val)"
                      hide-details="auto"
                      dense
                    ></v-select>
                  </v-col>
                  <v-col
                    md="3"
                    class="pl-2 pr-2"
                  >
                    <v-select
                      v-model="foresiteMetadata.flight_from"
                      :items="campaignQuarterOptions"
                      item-text="name"
                      item-value="value"
                      label="Flight From"
                      :readonly="hasLake5Destination || !hasPublishPermissions"
                      @input="val => $emit('input', val)"
                      hide-details="auto"
                      dense
                    ></v-select>
                  </v-col>
                  <v-col
                    md="3"
                    class="pl-2 pr-0"
                  >
                    <v-select
                      v-model="foresiteMetadata.flight_to"
                      :items="flightToOptions"
                      item-text="name"
                      item-value="value"
                      label="Flight To"
                      :readonly="hasLake5Destination || !hasPublishPermissions"
                      :disabled="!foresiteMetadata.flight_from"
                      @input="val => $emit('input', val)"
                      hide-details="auto"
                      dense
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row
                  justify="space-between"
                  class="pa-0 pl-3 pr-3"
                >
                  <v-col
                    md="9"
                    class="pl-0 pr-2"
                  >
                    <v-text-field
                      dense
                      :readonly="hasLake5Destination || !hasPublishPermissions"
                      hide-details="auto"
                      label="Lake5 Name"
                      v-model="foresiteMetadata.lake5_name"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    md="3"
                    class="pl-2 pr-0"
                  >
                    <!-- <v-text-field dense :readonly="hasLake5Destination || !hasPublishPermissions" label="Demo ID" v-model="foresiteMetadata.demo_id" :rules="demoIdRules" hide-details="auto"></v-text-field> -->
                    <demo-id
                      :initialValue="foresiteMetadata.demo_id"
                      :readonly="hasLake5Destination || hasDemoId || !hasPublishPermissions"
                      @updatedDemoId="val => (foresiteMetadata.demo_id = val)"
                    >
                    </demo-id>
                  </v-col>
                </v-row>
                <v-row
                  justify="space-between"
                  class="pa-3 pb-0"
                >
                  <!-- <v-col md="10" class="pb-0"> -->
                  <v-textarea
                    dense
                    outlined
                    :readonly="hasLake5Destination || !hasPublishPermissions"
                    hide-details="auto"
                    label="Notes"
                    v-model="foresiteMetadata.lake5_notes"
                    height="90"
                    no-resize
                    :rules="notesRules"
                  ></v-textarea>
                  <!-- </v-col> -->
                </v-row>
              </template>
              <template v-if="showVideoampMetadata">
                <v-row
                  justify="space-between"
                  class="pa-0 pl-3 pr-3"
                >
                  <v-col
                    md="3"
                    class="pl-0 pr-2"
                  >
                    <campaign-quarter-select
                      :initialValue="videoampMetadata.campaign_quarter"
                      :readonly="hasLake5Destination"
                      @updatedCampaignQuarter="val => (videoampMetadata.campaign_quarter = val)"
                    >
                    </campaign-quarter-select>
                  </v-col>
                  <v-col
                    md="3"
                    class="pl-2 pr-2"
                  >
                    <v-text-field
                      dense
                      :readonly="hasLake5Destination"
                      hide-details="auto"
                      label="Advertiser"
                      v-model="videoampMetadata.advertiser"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    md="3"
                    class="pl-2 pr-0"
                  >
                    <v-text-field
                      dense
                      readonly
                      hide-details="auto"
                      label="Currency"
                      v-model="videoampMetadata.currency"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row
                  justify="space-between"
                  class="pa-0 pl-3 pr-3"
                >
                  <v-col
                    md="3"
                    class="pl-0 pr-2"
                  >
                    <v-text-field
                      dense
                      :readonly="hasLake5Destination"
                      hide-details="auto"
                      label="VideoAmp ID"
                      v-model="videoampMetadata.videoamp_id"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    md="3"
                    class="pl-2 pr-2"
                  >
                    <v-text-field
                      dense
                      :readonly="hasLake5Destination"
                      hide-details="auto"
                      label="Deal Number"
                      v-model="videoampMetadata.deal_number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    md="3"
                    class="pl-2 pr-0"
                  >
                    <demo-id
                      :initialValue="videoampMetadata.demo_id"
                      :readonly="hasLake5Destination"
                      @updatedDemoId="val => (videoampMetadata.demo_id = val)"
                    >
                    </demo-id>
                  </v-col>
                </v-row>
              </template>
            </v-col>
            <v-col
              v-if="!showDestinations"
              md="6"
              lg="5"
            >
              <v-spacer></v-spacer>
            </v-col>
            <v-col
              v-if="showDestinations"
              md="6"
              lg="5"
            >
              <v-row class="justify-center">
                <v-subheader>Destinations</v-subheader>
              </v-row>
              <v-row class="inline-flex justify-center">
                <v-col
                  md="3"
                  v-for="destination in destinations"
                  :key="destination.id"
                >
                  <MVPD
                    :destination="destination"
                    :selected="audience.destinations.includes(destination.id)"
                    :canUpdate="canUpdateUE()"
                    :showUE="showUEHoverOver"
                    :UE="getUE(destination)"
                    :MRM_ID="getmrmId(destination)"
                    :minWidth="destinationWidth"
                    :showMRM_ID="false"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions
        v-if="!isLoading && showUpdate"
        class="justify-center pt-0 pb-7"
      >
        <!-- <v-btn :disabled="(!isMrmIdUpdated && !isUeUpdated && !isForesiteMetadataUpdated)" color="success" @click="updateAudience">update</v-btn> -->
        <v-btn
          :disabled="!canUpdate"
          color="success"
          @click="updateAudience"
          >{{ buttonLabel }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import MVPD from '@/appComponents/targets/createTarget/components/MVPD'
  import CampaignQuarterSelect from '@/appComponents/targets/createTarget/components/CampaignQuarterSelect'
  import DemoId from '@/appComponents/targets/createTarget/components/DemoId'

  import { convertViewingStreamFullName } from '@/appLogic/targets/conversions'
  import { cloneDeep } from 'lodash'

  import { saveTarget, sendToLake5, updateTargetUE } from '@/api'
  import { getCampaignQuarters } from '@/common/U_D'
  import { FETCH_SINGLE_AUDIENCE, REPLACE_TARGET, SET_REFRESH_TABLE_FLAG } from '@/views/audienceHub/store/actions'
  import { SET_CURRENT_TARGET } from '@/appLogic/targets/currentTarget/store/actions'
  import Toast from '@/components/common/toasts'
  import {
    DESTINATIONS,
    DESTINATION_OBJECTS,
    ACTIVATION_STATUS,
    DESTINATIONS_ID,
    EXTERNAL_ENDPOINTS,
    MARKETPLACE_ENDPOINTS,
    TARGET_TYPE,
    EXPORT_DAY_OF_WEEK,
    DIGITAL_DESTINATIONS,
  } from '@/appLogic/targets/Constants'

  export default {
    components: {
      MVPD,
      CampaignQuarterSelect,
      DemoId,
    },
    data: function () {
      return {
        audience: {},
        destinations: [],
        isLoading: true,
        destinationWidth: '76px',
        height: 445,
        MVPDs: [],
        ue: null,
        mrm_id: null,
        isMounted: false,
        fetchPromise: null,
        UERules: [
          value => (value && !isNaN(value)) || value === '' || 'Enter only numeric values',
          value => (value && value >= 1000000) || 'Min value 1000000',
          value => (value && value <= 310000000) || 'Max value 310000000',
          // v-model="ue"
          //       separator=","
          //       :readOnly="false"
          //       :shouldValidate="false"
          //       text="UE:"
        ],
        mrmIdRules: [value => (value && !isNaN(value)) || value === '' || 'Enter only numeric values'],
        isMrmIdUpdated: false,
        isUeUpdated: false,
        showUpdate: false,
        digitalDestinations: [DESTINATIONS.FREEWHEEL, DESTINATIONS.GOOGLE_AD_MANAGER, DESTINATIONS.VIDEOAMP],
        foresiteMetadata: {
          pid_file_name: null,
          demo_id: null,
          flight_from: null,
          flight_to: null,
          lake5_name: null,
          quarter_matched_to: null,
          campaign_quarter: null,
          lake5_notes: null,
        },
        demoIdRules: [value => (value && !isNaN(value)) || value === '' || 'Numeric values only'],
        notesRules: [value => (value || '').length <= 100 || 'Description must be 100 characters or less'],
        isForesiteMetadataUpdated: false,
        videoampMetadata: {
          campaign_quarter: null,
          advertiser: null,
          videoamp_id: null,
          currency: 'VideoAmp',
          deal_number: null,
          demo_id: null,
        },
      }
    },
    beforeMount() {
      // Initialize MVPDs early to ensure they're available
      this.initializeMVPDs()
    },
    mounted() {
      // Prevent duplicate mounting and API calls
      if (this.isMounted || this.fetchPromise) {
        return
      }

      this.isMounted = true
      this.fetchAudienceData()
    },
    beforeDestroy() {
      // Mark component as unmounted to prevent state updates
      this.isMounted = false
    },
    computed: {
      buttonLabel() {
        return this.showForesiteMetadata ? 'submit' : 'update'
      },
      advertiserName() {
        return (this.audience.advertiser && this.audience.advertiser.Name) || ''
      },
      viewingStream() {
        return convertViewingStreamFullName(this.audience.viewing_stream || '')
      },
      frequency() {
        return (this.audience.xandr_data && this.audience.xandr_data.frequency) || null
      },
      exportDayOfWeek() {
        if (this.audience.xandr_data && this.audience.xandr_data.exportDayOfWeek !== undefined) {
          for (const d of EXPORT_DAY_OF_WEEK) {
            if (d.value === this.audience.xandr_data.exportDayOfWeek) {
              return d.Name
            }
          }
        }
        return null
      },
      campaignName() {
        return (
          (this.audience.xandr_data &&
            this.audience.xandr_data.campaign &&
            this.audience.xandr_data.campaign.campaignName) ||
          null
        )
      },
      showDestinations() {
        return this.destinations && this.destinations.length > 0
      },
      isFlightDatesNotNull() {
        return this.audience.am_data && this.audience.am_data.flightStartDate && this.audience.am_data.flightEndDate
      },
      flightStartDate() {
        if (this.audience.am_data && this.audience.am_data.flightStartDate) {
          return this.audience.am_data.flightStartDate.split('T')[0]
        }
        return ''
      },
      flightEndDate() {
        if (this.audience.am_data && this.audience.am_data.flightEndDate) {
          return this.audience.am_data.flightEndDate.split('T')[0]
        }
        return ''
      },
      isLasActivatedAndNoUE() {
        return (
          this.audience.target === TARGET_TYPE.LAS &&
          this.audience.activation_status === ACTIVATION_STATUS.ACTIVATED &&
          !this.audience.audience_size
        )
      },
      hasDigitalDestinations() {
        return this.audience && this.audience.destinations.some(a => DIGITAL_DESTINATIONS.includes(a))
      },
      isDigitalTarget() {
        return (
          this.audience &&
          Object.values(this.$root.$store.getters.getC360Datasources).includes(this.audience.target_datasource)
        )
      },
      showForesiteMetadata() {
        return this.hasForesiteDestination && (this.isLiveStatus || this.isFailedStatus)
      },
      hasForesiteDestination() {
        return this.audience && this.audience.destinations.includes(DESTINATIONS.FORESITE)
      },
      hasLake5Destination() {
        return this.audience && this.audience.destinations.includes(DESTINATIONS.LAKE5)
      },
      hasDemoId() {
        return (
          this.audience &&
          this.audience.metadata &&
          this.audience.metadata.foresite &&
          this.audience.metadata.foresite.demo_id
        )
      },
      showVideoampMetadata() {
        return this.audience && this.audience.metadata.videoamp
      },
      isLiveStatus() {
        return this.audience && this.audience.activation_status === ACTIVATION_STATUS.LIVE
      },
      isWorkingStatus() {
        return this.audience && this.audience.activation_status === ACTIVATION_STATUS.WORKING
      },
      isFailedStatus() {
        return this.audience && this.audience.activation_status === ACTIVATION_STATUS.FAILED
      },
      universeEstimate: {
        get() {
          return this.ue
        },
        set(newValue) {
          if (
            !isNaN(newValue) &&
            Number.isInteger(parseFloat(newValue)) &&
            newValue >= 1000000 &&
            newValue <= 310000000
          ) {
            this.ue = newValue
            this.isUeUpdated = true
          } else {
            this.ue = newValue
            this.isUeUpdated = false
          }
        },
      },
      showUEHoverOver() {
        return (
          this.audience.activation_status === ACTIVATION_STATUS.ACTIVATED ||
          this.audience.activation_status === ACTIVATION_STATUS.SUBMITTED ||
          this.audience.activation_status === ACTIVATION_STATUS.LIVE ||
          this.audience.activation_status === ACTIVATION_STATUS.FAILED
        )
      },
      originalMrmId() {
        if (!this.audience.xandr_data.external) {
          return null
        }
        const canoeExternal = this.audience.xandr_data.external.find(
          dest =>
            dest.endpointName === MARKETPLACE_ENDPOINTS.CANOE_LINEAR ||
            dest.endpointName === MARKETPLACE_ENDPOINTS.CANOE_VOD,
        )
        return canoeExternal ? canoeExternal.externalID : ''
      },
      mrmId: {
        get() {
          return this.mrm_id
        },
        set(newValue) {
          if (this.originalMrmId !== newValue && !isNaN(newValue) && Number.isInteger(parseFloat(newValue))) {
            this.mrm_id = newValue
            this.isMrmIdUpdated = true
          } else {
            this.mrm_id = newValue
            this.isMrmIdUpdated = false
          }
        },
      },
      showMrmId() {
        return (
          this.hasCanoeDestination &&
          (this.audience.activation_status === ACTIVATION_STATUS.ACTIVATED ||
            this.audience.activation_status === ACTIVATION_STATUS.SUBMITTED)
        )
      },
      showBroadcastQuarter() {
        return (
          (this.audience.target === TARGET_TYPE.PID || this.audience.target === TARGET_TYPE.LAS) &&
          this.audience.target_definition &&
          this.audience.target_definition.broadcastQuarter
        )
      },
      broadcastQuarter() {
        return this.audience.target_definition && this.audience.target_definition.broadcastQuarter
          ? this.audience.target_definition.broadcastQuarter.replace('_', ' ')
          : ''
      },
      demoQualifier() {
        return this.audience.metadata &&
          this.audience.metadata.foresite &&
          this.audience.metadata.foresite.demoQualifier
          ? this.audience.metadata.foresite.demoQualifier
          : ''
      },
      isEveryForesiteMetadataUpdated() {
        const foresiteMetaDataKeys = ['demo_id', 'flight_from', 'flight_to', 'lake5_name', 'campaign_quarter']
        return foresiteMetaDataKeys.every(
          key =>
            this.foresiteMetadata.hasOwnProperty(key) &&
            this.foresiteMetadata[key] !== null &&
            this.foresiteMetadata[key] !== '',
        )
      },
      isEveryVideoampMetadataUpdated() {
        const videoampMetaDataKeys = Object.keys(this.videoampMetadata)
        return videoampMetaDataKeys.every(
          key =>
            this.videoampMetadata.hasOwnProperty(key) &&
            this.videoampMetadata[key] !== null &&
            this.videoampMetadata[key] !== '',
        )
      },
      isVideoampMetadataUpdated() {
        const videoampMetaDataKeys = Object.keys(this.videoampMetadata)
        const isVideoampMetadataUpdated = videoampMetaDataKeys.find(
          key =>
            this.videoampMetadata[key] !== null &&
            this.audience.metadata.videoamp &&
            this.audience.metadata.videoamp[key] !== null &&
            this.videoampMetadata[key] !== this.audience.metadata.videoamp[key],
        )
        return isVideoampMetadataUpdated
      },
      pidFileName() {
        return (
          (this.audience.metadata &&
            this.audience.metadata.foresite &&
            this.audience.metadata.foresite.pid_file_name) ||
          null
        )
      },
      campaignQuarterOptions() {
        return getCampaignQuarters()
      },
      flightToOptions() {
        let flightFrom = this.foresiteMetadata.flight_from
        let flightTo = this.foresiteMetadata.flight_to
        if (!flightFrom) {
          return
        }
        if (flightTo) {
          if (
            flightFrom.substring(2).localeCompare(flightTo.substring(2)) > 0 ||
            (flightFrom.substring(2).localeCompare(flightTo.substring(2)) === 0 &&
              flightFrom.substring(0, 2).localeCompare(flightTo.substring(0, 2)) > 0)
          ) {
            this.foresiteMetadata.flight_to = ''
          }
        }
        let options = getCampaignQuarters().filter(x => {
          let yearDiff = x.value.substring(2).localeCompare(flightFrom.substring(2))
          if (yearDiff === 0) {
            if (x.value.substring(0, 2).localeCompare(flightFrom.substring(0, 2)) >= 0) {
              return true
            }
          } else if (yearDiff > 0) {
            return true
          }
        })
        return options
      },
      hasPublishPermissions() {
        return this.$root.$store.getters.hasPublishPermissions
      },
      canUpdate() {
        if (
          this.foresiteMetadata &&
          this.foresiteMetadata.lake5_notes &&
          this.foresiteMetadata.lake5_notes.length > 100
        ) {
          return false
        }
        if (this.isFailedStatus) return false
        return (
          this.hasPublishPermissions &&
          (this.isMrmIdUpdated || this.isUeUpdated || this.isForesiteMetadataUpdated || this.isVideoampMetadataUpdated)
        )
      },
      hasCanoeDestination() {
        return (
          this.audience &&
          (this.audience.destinations.includes(DESTINATIONS.CANOE_LINEAR) ||
            this.audience.destinations.includes(DESTINATIONS.CANOE_VOD))
        )
      },
      oarUE() {
        if (this.audience.destinations.includes(DESTINATIONS.VIZIO)) {
          var vizioDestination =
            this.audience.xandr_data &&
            this.audience.xandr_data.icd38 &&
            this.audience.xandr_data.icd38.find(x => x.destinationID === DESTINATIONS_ID.VIZIO)
          return (vizioDestination && vizioDestination['ueSize']) || 0
        }
      },
      dtvUE() {
        if (this.audience.destinations.includes(DESTINATIONS.DIRECTV)) {
          const dtvExternal =
            this.audience.xandr_data && this.audience.xandr_data.external
              ? this.audience.xandr_data.external.find(dest => dest.endpointName === MARKETPLACE_ENDPOINTS.DIRECTV)
              : null
          return (dtvExternal && dtvExternal.universeEstimates) || 0
        }
      },
      canoeVodUE() {
        if (this.audience.destinations.includes(DESTINATIONS.CANOE_VOD)) {
          const canoeVodExternal =
            this.audience.xandr_data && this.audience.xandr_data.external
              ? this.audience.xandr_data.external.find(dest => dest.endpointName === MARKETPLACE_ENDPOINTS.CANOE_VOD)
              : null
          return (canoeVodExternal && canoeVodExternal['universeEstimates']) || 0
        }
      },
      canoeLinearUE() {
        if (this.audience.destinations.includes(DESTINATIONS.CANOE_LINEAR)) {
          const canoeLinearExternal =
            this.audience.xandr_data && this.audience.xandr_data.external
              ? this.audience.xandr_data.external.find(dest => dest.endpointName === MARKETPLACE_ENDPOINTS.CANOE_LINEAR)
              : null
          return (canoeLinearExternal && canoeLinearExternal['universeEstimates']) || 0
        }
      },
    },
    methods: {
      initializeMVPDs() {
        // Initialize MVPDs safely with proper error handling
        try {
          if (this.$store && this.$store.state && this.$store.state.createTarget) {
            this.MVPDs = this.$store.state.createTarget.mvpds || []
          } else {
            this.MVPDs = []
          }
        } catch (error) {
          console.warn('Failed to initialize MVPDs:', error)
          this.MVPDs = []
        }
      },

      fetchAudienceData() {
        this.fetchPromise = this.$store
          .dispatch(FETCH_SINGLE_AUDIENCE, this.params.data)
          .then(this.handleAudienceDataSuccess)
          .catch(this.handleAudienceDataError)
          .finally(() => {
            this.fetchPromise = null
          })
      },

      handleAudienceDataSuccess(audienceData) {
        // Check if component is still mounted before updating data
        if (!this.isMounted) {
          return
        }

        try {
          this.audience = Array.isArray(audienceData) ? audienceData[0] : audienceData
          this.destinationWidth = '76px'

          this.setupDestinations()
          this.setupMVPDData()
          this.setupMetadata()
          this.setupUpdateFlags()

          this.ue = this.audience.audience_size
          this.isLoading = false
        } catch (error) {
          console.error('Error processing audience data:', error)
          this.isLoading = false
        }
      },

      handleAudienceDataError(error) {
        if (this.isMounted) {
          console.error('Error fetching audience data:', error)
          this.isLoading = false
        }
      },

      setupDestinations() {
        this.destinations = DESTINATION_OBJECTS.filter(d => {
          if (this.audience.destinations && this.audience.destinations.includes(d.id)) {
            return d.id
          }
        })
      },

      setupMVPDData() {
        // Ensure MVPDs are initialized
        if (!this.MVPDs || this.MVPDs.length === 0) {
          this.initializeMVPDs()
        }

        if (this.audience.xandr_data && this.audience.xandr_data.external && this.MVPDs.length > 0) {
          const canoeLinearMVPD = this.MVPDs.find(mvpd => mvpd && mvpd.Name === MARKETPLACE_ENDPOINTS.CANOE_LINEAR)
          const canoeVodMVPD = this.MVPDs.find(mvpd => mvpd && mvpd.Name === MARKETPLACE_ENDPOINTS.CANOE_VOD)

          if (this.audience.xandr_data.external) {
            this.audience.xandr_data.external.forEach(destination => {
              if (canoeLinearMVPD && destination.endpointID === canoeLinearMVPD.Id) {
                this.mrm_id = destination.externalID
              } else if (canoeVodMVPD && destination.endpointID === canoeVodMVPD.Id) {
                this.mrm_id = destination.externalID
              }
            })
          }
        }
      },

      setupMetadata() {
        if (this.pidFileName && this.audience.metadata && this.audience.metadata.foresite) {
          this.foresiteMetadata = { ...this.audience.metadata.foresite }
        }
        if (this.showVideoampMetadata && this.audience.metadata && this.audience.metadata.videoamp) {
          this.videoampMetadata = { ...this.audience.metadata.videoamp }
        }
      },

      setupUpdateFlags() {
        if (
          this.isLasActivatedAndNoUE ||
          this.showMrmId ||
          ((this.showForesiteMetadata || this.showVideoampMetadata) && !this.hasLake5Destination)
        ) {
          this.showUpdate = true
        }
      },

      updateAudience() {
        if (this.isMrmIdUpdated) {
          this.isMrmIdUpdated = false

          const externalCopy = cloneDeep(this.audience.xandr_data.external)
          externalCopy.forEach(destination => {
            if (
              destination.endpointName === MARKETPLACE_ENDPOINTS.CANOE_LINEAR ||
              destination.endpointName === MARKETPLACE_ENDPOINTS.CANOE_VOD
            ) {
              destination.externalID = this.mrm_id
            }
          })
          this.audience.xandr_data.external = externalCopy
          const updatedTarget = cloneDeep(this.audience)
          saveTarget(updatedTarget).then(resp => {
            this.$root.$store.dispatch(SET_CURRENT_TARGET, updatedTarget)
            this.$root.$store.dispatch(REPLACE_TARGET, updatedTarget)
          })
        }

        if (this.isForesiteMetadataUpdated && !this.audience.destinations.includes(DESTINATIONS.LAKE5)) {
          this.isForesiteMetadataUpdated = false
          this.audience.metadata.foresite = {
            ...this.audience.metadata.foresite,
            ...this.foresiteMetadata,
          }
          this.audience.destinations.push(DESTINATIONS.LAKE5)
          const updatedTarget = cloneDeep(this.audience)
          saveTarget(updatedTarget)
            .then(resp => {
              this.$root.$store.dispatch(SET_CURRENT_TARGET, updatedTarget)
              this.$root.$store.dispatch(REPLACE_TARGET, updatedTarget)
              this.destinations = DESTINATION_OBJECTS.filter(d => {
                if (this.audience.destinations.includes(d.id)) {
                  return d.id
                }
              })
            })
            .then(() => sendToLake5(updatedTarget))
            .then(() => {
              Toast.success({
                title: `Audience Updated`,
                message: `Audience info sent to Lake5`,
              })
            })
        }

        if (this.isVideoampMetadataUpdated && !this.audience.destinations.includes(DESTINATIONS.LAKE5)) {
          this.audience.metadata.videoamp = {
            ...this.audience.metadata.videoamp,
            ...this.videoampMetadata,
          }

          const updatedTarget = cloneDeep(this.audience)
          saveTarget(updatedTarget)
            .then(resp => {
              this.$root.$store.dispatch(SET_CURRENT_TARGET, updatedTarget)
              this.$root.$store.dispatch(REPLACE_TARGET, updatedTarget)
            })
            .then(() => {
              Toast.success({
                title: `Audience Updated`,
                message: `Videoamp Metadata for Audience updated`,
              })
            })
        }

        if (this.isUeUpdated) {
          this.isUeUpdated = false
          this.$root.$store.dispatch(SET_REFRESH_TABLE_FLAG, false)
          updateTargetUE({ targetId: this.audience.id, ue: this.ue })
            .then(resp => {
              Toast.success({
                title: `Audience Updated`,
                message: `UE updated successfully`,
              })
              this.$root.$store.dispatch(SET_REFRESH_TABLE_FLAG, true)
            })
            .catch(err => {
              Toast.error({ title: 'Error updating target UE', message: err.message })
              console.log(err)
            })
        }
      },
      updateMrmID(mrmId) {
        console.log(mrmId)
      },
      canUpdateUE() {
        return false
      },
      getUE(destination) {
        switch (destination.id) {
          case DESTINATIONS.DIRECTV:
            return this.dtvUE
          case DESTINATIONS.VIZIO:
            return this.oarUE
          case DESTINATIONS.CANOE_LINEAR:
            return this.canoeLinearUE
          case DESTINATIONS.CANOE_VOD:
            return this.canoeVodUE
          case DESTINATIONS.SYMPHONY:
            return Number(this.audience.audience_size)
          default:
            return null
        }
      },
      getmrmId(destination) {
        return ''
        // if (destination && destination.id === DESTINATIONS.CANOE_LINEAR) {
        //   return this.mrmId || this.originalMrmId
        // } else {
        //   return ''
        // }
      },
    },
    watch: {
      isEveryForesiteMetadataUpdated(value) {
        this.isForesiteMetadataUpdated = value
      },
    },
  }
</script>
<style scoped>
  :deep(.v-text-field .v-label) {
    left: 0px !important;
    right: auto !important;
  }
</style>



// WEBPACK FOOTER //
// AudienceDetailRenderer.vue?24f370b4